import dayjs from 'dayjs';

/**
 * Adjusts a given date to the nearest Monday (previous Monday if not already Monday).
 * For Sunday, goes back to the previous Monday (6 days back).
 * For any other day, goes back to the start of that week (Monday).
 *
 * @param date - The date to adjust (string in YYYY-MM-DD format or dayjs object)
 * @returns The adjusted date as a dayjs object
 */
export function adjustToMonday(date: string | dayjs.Dayjs): dayjs.Dayjs {
    const selectedDate = typeof date === 'string' ? dayjs(date) : date;
    const dayOfWeek = selectedDate.day(); // 0 = Sunday, 1 = Monday, etc.

    if (dayOfWeek === 1) {
        // Already Monday
        return selectedDate;
    }

    // If Sunday (0), go back 6 days; otherwise go back to previous Monday
    const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    return selectedDate.subtract(daysToSubtract, 'day');
}

/**
 * Gets the current week's Monday.
 *
 * @returns The Monday of the current week as a dayjs object
 */
export function getCurrentMonday(): dayjs.Dayjs {
    return adjustToMonday(dayjs());
}

/**
 * Checks if a given date is a Monday.
 *
 * @param date - The date to check (string in YYYY-MM-DD format or dayjs object)
 * @returns true if the date is a Monday, false otherwise
 */
export function isMonday(date: string | dayjs.Dayjs): boolean {
    const selectedDate = typeof date === 'string' ? dayjs(date) : date;
    return selectedDate.day() === 1;
}
